module.exports = __webpack_public_path__ + "img/contrato64.7aee6ff8.png";